import * as XLSX from 'xlsx';
import { FormFieldConfig } from '../types/formField.types';
import { isYupValid } from './fieldConfigHelpers';
import { optionsField } from './formFields';
import * as Yup from 'yup';

export const generateSampleExcel = (columns: any[], moduleTitle:string) => {
  const title = moduleTitle.replace(/\s+/g, '-')
  const sample: Record<string, any>[] = [{}];
  columns.forEach(col => {
    sample[0][col.headerName] = col.example || '';
  });

  const worksheet = XLSX.utils.json_to_sheet(sample);

  // Set column widths dynamically based on the values
  const columnWidths = columns.map(col => ({
    wch: Math.max(col.headerName.length, (col.example || '').toString().length)
  }));
  worksheet['!cols'] = columnWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, title);
  XLSX.writeFile(workbook, title+'-upload.xlsx');
};

export function mapExcelRowsToFields(
  config: any[],
  excelRows: any[]
): Record<string, any>[] {
  const headerToFieldMap = config.reduce((acc, col: any) => {
    acc[col.headerName] = col.field;
    return acc;
  }, {} as Record<string, string>);

  return excelRows.map(row => {
    const newRow: Record<string, any> = {};
    for (const [header, value] of Object.entries(row)) {
      const field = headerToFieldMap[header];
      if (field) {
        newRow[field] = value;
      }
    }
    return { ...newRow, excelDeleted: false }; // Initialize errors as empty
  });
}


export const validateExcelRows = (data: any[], config: FormFieldConfig[]): any[] => {
  const errors: any[] = [];
  data.forEach((row: any, rowIndex) => {
    const rowErrors: any = {};
    config.forEach(({ name, yup, type, options }) => {
      const value = name ? row[name] : undefined;

      /* valid option from the list */
      const isSelect = optionsField.includes(type || "");
      let finalYup = yup;
      if (value && isSelect && options) {
        const validValues = options.map(opt => opt.label);
        finalYup = (yup ?? Yup.mixed()).oneOf(validValues, `Please choose a valid option from the list.`);
      }

      const isValid = isYupValid(value, finalYup);
      if (finalYup && !isValid.status) {
        rowErrors[name || ""] = isValid.message; // Collect error message
      }
    });
    errors[rowIndex] = rowErrors; // Store errors for this row 
  });
  return errors;
};



export const convertDropdownLabelsToValues = (row: any, fieldConfig: FormFieldConfig[]) => {
  const newRow: Record<string, any> = { ...row };

  fieldConfig.forEach((field) => {
    const { name, type, options } = field;
    const isSelect = optionsField.includes(type || '');

    if (isSelect && Array.isArray(options)) {
      const match = options.find((opt) => opt.label === row[name]);
      if (match) {
        newRow[name] = match.value;
      }
    }
  });

  return newRow;
};